export { Iconify1 } from "./Iconify1";
